/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TEXT from "../../../../utils/globalText";
// Component

import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { reimbursementTxnRequestSuccessDetail } from "../../../../redux/features/reimbursementTransaction";
import useCategories from "../../../../utils/useCategories";

const ReimbursementTxnSuccessPage = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    reimbursementTxnSuccessRequestData,
    reimbursementTxnSuccessRequestLoading,
  } = useSelector((state) => state.reimbursementTransaction);

  const categoryMapper = useCategories();
  const location = useLocation();
  const Requestlocation = location?.state;
  const transactionId =
    reimbursementTxnSuccessRequestData?.request?.[0]
      ?.beneficiary_transactions_details?.beneficiary_transaction_id;
  const assignedLabels =
    reimbursementTxnSuccessRequestData?.request?.[0]?.labels;

  useEffect(() => {
    dispatch(disableSwitcher());
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(reimbursementTxnRequestSuccessDetail(id));
  }, [id]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementTxnSuccessRequestData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
      {
        replace: true,
      },
    );
  };

  const createAccountHandler = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
      {
        replace: true,
      },
    );
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_transaction_dashboard", {
      replace: true,
    });
  };

  // Button

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  const RequestbuttonRows = [
    [
      {
        btnText: "View request details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: () =>
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_request_view_all/reimbursement_request_detail_page/${Requestlocation?.Request_id}`,
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View transaction details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: () => {
          navigate(
            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementTxnSuccessRequestData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      // {
      //   btnText: "View details",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS?.VIEW_DETAILS,
      //   handleFunction: viewDetailsHandler,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];
  const categoryIcon = categoryMapper(
    reimbursementTxnSuccessRequestData?.request[0]?.category_id?.category_id,
  );

  return (
    <>
      <StatusContainer
        isLoading={reimbursementTxnSuccessRequestLoading}
        status="success"
        hoverOption="black"
        title={`${
          Requestlocation?.type === "PayReimburseTxn"
            ? "Request approved and transaction created successfully."
            : "Reimbursement transaction has been created successfully and awaiting approval."
        }`}
        buttonRows={
          Requestlocation?.type === "PayReimburseTxn"
            ? RequestbuttonRows
            : buttonRows
        }
      >
        <TabsWeapperSection title="Transaction details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          reimbursementTxnSuccessRequestData?.request[0]
                            ?.reimbursement_amount
                        }
                      />
                    </>
                  ),
                  leftSubTitle: "Approved amount",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          reimbursementTxnSuccessRequestData?.request[0]
                            ?.requested_amount
                        }
                      />
                    </>
                  ),
                  leftSubTitle: "Requested amount",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_name,
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]?.category_id
                      ?.category_name,
                  leftSubTitle: "Category",
                  icon: categoryIcon.url,
                  iconColor: categoryIcon.colour,
                  iconSize: "small",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${reimbursementTxnSuccessRequestData?.request[0]?.owner_account_id}`,
                )
              }
              //   handleFunction={}
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: reimbursementTxnSuccessRequestData?.request[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            />
            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${reimbursementTxnSuccessRequestData?.request[0]?.beneficiary_account_id}`,
                )
              }
              //   handleFunction={}
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.DESTINATION_ACCOUNT_NUMBER,
                  ifsc: reimbursementTxnSuccessRequestData?.request[0]
                    ?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]?.logs[0]
                      ?.user_full_name,
                  leftSubTitle: "Username",
                  showRowDivider: true,
                },
                {
                  leftTitle:
                    reimbursementTxnSuccessRequestData?.request[0]
                      ?.created_by_name,
                  leftSubTitle: "User ID",
                },
              ]}
              showRowDivider={true}
              rowBorderColor="var(--positive-bg)"
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(assignedLabels) && assignedLabels.length > 0
                      ? assignedLabels.join(", ")
                      : TEXT.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: transactionId || "Not available",
                  leftSubTitle: "Transaction ID",
                  copyText: transactionId,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default ReimbursementTxnSuccessPage;
